import { withIcon } from "../Icon"

export const IconTender = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 20h9.23M12 20v-3.078H5.23V20M12.968 4.87 8.556 9.286c-.48.48-.48 1.26 0 1.741l1.95 1.95c.48.481 1.26.481 1.74 0l4.412-4.414c.481-.48.481-1.26 0-1.741L14.71 4.87a1.23 1.23 0 0 0-1.74 0ZM14.461 10.766 20 16.306"/>',
)
